import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IVendorCommentData } from 'types/order/comment/IVendorComment';
import { TOrderPayload } from 'types/order/vendorDashboard/TOrderPayload';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { commentsInitialState } from './interfaces';

export const vendorCommentsReducer = createSlice({
  name: 'vendorComments',
  initialState: commentsInitialState,
  reducers: {
    setVendorCommentsAction: (state, action: PayloadAction<TOrderPayload<IVendorCommentData[]>>) => {
      state.comments[action.payload.orderId] = action.payload.value;
    },
    setVendorCommentsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.getCommentsFetchStatus = action.payload;
    },
    setVendorCommentsErrorAction: (state, action: PayloadAction<string | undefined>) => {
      state.getCommentsError = action.payload;
    },
    setPostVendorCommentsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.postCommentFetchStatus = action.payload;
    },
    setPostVendorCommentsErrorAction: (state, action: PayloadAction<string | undefined>) => {
      state.postCommentError = action.payload;
    },
  },
});
export const {
  setVendorCommentsAction,
  setVendorCommentsFetchStatusAction,
  setVendorCommentsErrorAction,
  setPostVendorCommentsFetchStatusAction,
  setPostVendorCommentsErrorAction,
} = vendorCommentsReducer.actions;
